import { useEffect, useRef } from 'react';
import flvjs from 'flv.js';
const CamaraVisor = ({ id = "", vehiculo = null, checked = false, urlVideo = "", api_grupo = 0 }) => {

    let visor = useRef();
    let containerRef = useRef();

    useEffect(() => {

        if (checked && urlVideo.length > 0) {
            if (api_grupo === 3) {
                const video = document.createElement('video');
                video.className = 'video-js vjs-default-skin';
                video.setAttribute('controls', true);
                video.setAttribute('preload', 'none');
                video.setAttribute('data-setup', '{}');
                video.style.width = "95%";
                video.style.aspectRatio = "16 / 9";
                video.style.display = 'none';

                // Clear container and add video
                containerRef.current.innerHTML = '';
                containerRef.current.appendChild(video);

                // Create and attach FLV player
                const player = flvjs.createPlayer(
                    {
                        type: 'flv',
                        url: urlVideo,
                        isLive: false,
                        hasAudio: false,
                        hasVideo: true,
                    },
                    {
                        enableStashBuffer: false,
                    }
                );

                player.attachMediaElement(video);
                player.load();
                player.play();

                visor = player;

                // Show the video element once playback starts
                video.addEventListener('loadeddata', () => {
                    video.style.display = 'inline-block';
                });
            } else {
                const options = {
                    domId: id,
                    isVodMode: true,
                    width: "100%",
                    height: 185,
                    lang: "en",
                }
                containerRef = new Cmsv6Player(options)

                containerRef.stopVideo(0);
                containerRef.setVideoInfo(0, vehiculo.no_economico);

                if (urlVideo.length > 0) {

                    containerRef.startVod(0, urlVideo, true);
                }
            }
        }

        return () => {
            try {
                if (api_grupo === 3) {
                    visor.destroy();
                    visor = null;
                    containerRef.destroy();
                    containerRef = null;
                } else {
                    containerRef.stopVideo(0);
                    console.log("stop video");
                }
            } catch (error) {

            }

            visor = null;
        }
    }, [urlVideo]);

    return (
        <>
            <div id={id} ref={containerRef}></div>
        </>
    )

}

export default CamaraVisor;